import React, { ReactNode } from 'react';
import Footer from '../components/Footer';

interface BaseLayoutProps {
  children: ReactNode;
  showFooter?: boolean;
  showNavbar?: boolean;
  className?: string;
}

export const BaseLayout: React.FC<BaseLayoutProps> = ({ 
  children, 
  showFooter = true,
  showNavbar = true,
  className = '' 
}) => {
  return (
    <div className={`min-h-screen flex flex-col ${className}`}>
      {/* Navbar is now rendered globally by AppLayout/Header. */}
      <main className="flex-1">
        {children}
      </main>
      {showFooter && <Footer />}
    </div>
  );
};
